import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  TextField
} from '@mui/material';
import { DataGrid, type GridPaginationModel } from '@mui/x-data-grid';
import { useEffect, useRef, useState } from 'react';
import type { PersonaRecibeResumen } from '../../stores/personal-recibe/persona-recibe';
import { usePersonalRecibeStore } from '../../stores/personal-recibe/personal-recibe.store';
import { useUIStore } from '../../stores/ui/ui.store';

interface PersonalRecibeSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (registro: PersonaRecibeResumen) => void;
}

const columnas = [
  { field: 'id', headerName: 'Código', width: 100, sortable: false },
  { field: 'nombre', headerName: 'Nombre', flex: 1, sortable: false },
  { field: 'ciudad', headerName: 'Ciudad', flex: 1, sortable: false },
  { field: 'estado', headerName: 'Estado', flex: 1, sortable: false }
];

const PersonalRecibeSearchDialog = ({
  open,
  onClose,
  onSelect
}: PersonalRecibeSearchDialogProps) => {
  const [filtro, setFiltro] = useState('');
  const [pagina, setPagina] = useState(0);
  const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const { loading } = useUIStore();
  const { list, cargarPaginadas } = usePersonalRecibeStore();

  const cargaRegistros = async () => {
    cargarPaginadas({
      columnaFiltro: 'nombre',
      columnaOrden: 'nombre',
      filtro,
      direccionOrden: 'asc',
      limite: 10,
      pagina,
      status: 'activos'
    });
  };

  const handleCambioFiltro = (value: string) => {
    setFiltro(value);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {}, 500);
  };

  const handleCambioPagina = (model: GridPaginationModel) => {
    setPagina(model.page);
  };

  useEffect(() => {
    if (open) {
      cargaRegistros();
    }
  }, [open, filtro, pagina]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Búsqueda de Personal que Recibe Ganado</DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
          <Paper variant="outlined" sx={{ padding: 2 }}>
            <TextField
              label="Filtro"
              placeholder="Comience a escribir para buscar..."
              value={filtro}
              onChange={(event) => handleCambioFiltro(event.target.value)}
              fullWidth
            />
          </Paper>
          <Paper sx={{ height: 350, width: '100%' }}>
            <DataGrid
              columns={columnas}
              rows={list.items}
              loading={loading}
              disableColumnResize
              paginationModel={{
                page: list.pageIndex,
                pageSize: list.pageSize
              }}
              onPaginationModelChange={handleCambioPagina}
              onRowDoubleClick={(model) => onSelect(model.row)}
              pageSizeOptions={[10]}
              rowCount={list.totalRows}
              paginationMode="server"
              autoHeight={false}
              disableColumnMenu
              disableRowSelectionOnClick
            />
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonalRecibeSearchDialog;
